import { OPPS_CLEAN_UP } from "../../actions/commonActions";
import { FETCH_WIN_OPPORTUNITIES_FAILURE, FETCH_WIN_OPPORTUNITIES_REQUEST, FETCH_WIN_OPPORTUNITIES_SUCCESS } from "../../actions/opportunities/winOpportunitiesActions";

  const initialState = {
    winOpportunitesLoading: false,
    winOpportunitesData: [],
    winOpportunitesError: null,
  };
  
  const winOpportunitiesReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_WIN_OPPORTUNITIES_REQUEST:
        return { ...state, winOpportunitesLoading: true , payload: action.payload};
      case FETCH_WIN_OPPORTUNITIES_SUCCESS:
        return { ...state, winOpportunitesLoading: false, winOpportunitesData: action.payload };
      case "FETCH_WIN_OPPORTUNITIES_UPDATE":
        return { ...state, winOpportunitesData:state.winOpportunitesData.map(item =>
          item._id === action.payload.oppId
            ? { ...item, is_bookmarked: action.payload.data }
            : item
        ) }; 
      case FETCH_WIN_OPPORTUNITIES_FAILURE:
        return { ...state, winOpportunitesLoading: false, winOpportunitesError: action.payload };
      case OPPS_CLEAN_UP:   
        return initialState
        
      default:
        return state;
    }
  };
  
  export default winOpportunitiesReducer;
  